import iridexLogo from "./iridex-white-stacked.png";

export {
  iridexLogo,
};
